// 问诊方式
export const inquiryTypeMap = [
  { label: '全部咨询方式', value: '' },
  { label: '图文咨询', value: 0 },
  { label: '视频咨询', value: 1 },
  { label: '电话咨询', value: 2 },
  { label: '门诊就诊', value: 3 }
]
// 处方状态
export const prescriptionStatusMap = [
  { label: '全部状态', value: '' },
  { label: '有处方', value: 1 },
  { label: '无处方', value: 0 }
]
